module.exports = __webpack_public_path__ + "img/ElectronicStudentCard.13fa26cf.png";